import { composeBundles } from "redux-bundler";
import videos from "./videos";
import ui from "./ui";

export default composeBundles(videos, ui);
